import { render } from "./Telebarq.vue?vue&type=template&id=4cc12a81&scoped=true"
import script from "./Telebarq.vue?vue&type=script&lang=js"
export * from "./Telebarq.vue?vue&type=script&lang=js"

import "./Telebarq.vue?vue&type=style&index=0&id=4cc12a81&scoped=true&lang=css"

import exportComponent from "/Users/alexmeister/Documents/GitHub/barq2_0_new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc12a81"]])

export default __exports__